import React from "react"
import {ApplicationStatus, ApproveMethodType, DecisionByEnum} from "../../resources/application"
import {
	ProductApplicationStatus,
	DecisionMethodType as ProductDecisionMethodType,
} from "../../resources/productApplication"
import {UserName} from "../Users/UserName"
import HorizontalField from "../HorizontalField/HorizontalField"
import {hasPermission} from "../../services/permission"

const decisionByToLabelMap: Record<DecisionByEnum, string> = {
	[DecisionByEnum.Unit]: "Unit User",
	[DecisionByEnum.Org]: "Org User",
	[DecisionByEnum.Bank]: "Bank User",
}

export default function DecisionBy({
	decisionUserId,
	decisionBy,
	decisionMethod,
	status,
	fieldClassName,
}: {
	decisionUserId?: string
	decisionBy?: DecisionByEnum
	decisionMethod?: ApproveMethodType | ProductDecisionMethodType
	status: ApplicationStatus | ProductApplicationStatus
	fieldClassName?: string
}) {
	const label = status === ApplicationStatus.Approved ? "Approved By" : "Denied By"

	if (decisionUserId && hasPermission("user", "get")) {
		return (
			<UserName
				element="div"
				userId={decisionUserId}
				onResult={(user) => (
					<HorizontalField label={label} fieldClassName={fieldClassName}>
						<input type="text" readOnly value={user.attributes.username} className="input is-static" />
					</HorizontalField>
				)}
				onFailed={() => <>Something has failed, please contact admin</>}
			/>
		)
	}

	if (decisionBy && decisionMethod === ApproveMethodType.Automatically) {
		return <></>
	}

	if (decisionBy) {
		return (
			<HorizontalField label={label} fieldClassName={fieldClassName}>
				<input type="text" readOnly value={decisionByToLabelMap[decisionBy]} className="input is-static" />
			</HorizontalField>
		)
	}

	return <></>
}
